var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfitIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.479 0.662092C5.85503 -0.045643 6.86916 -0.0456407 7.24518 0.662094L11.9572 9.5308C12.3111 10.1969 11.8284 11 11.0742 11H1.65003C0.895802 11 0.413055 10.1969 0.766938 9.5308L5.479 0.662092Z",
    fill: "#00B190"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfitIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profit icon.5d4c3dfeeee61271cfb17dda99cf46e5.svg";